export const MAX_STREET_INPUT_LENGTH = 100;
export const MIN_INPUT_LENGTH_FOR_SEARCH = 2;
export const GOOGLE_MAPS_DEBOUNCE_DELAY = 500;
export const GOOGLE_MAPS_PRIMARY_TYPES = ['geocode'];
export const ADDRESS_FIELDS: string[] = ['addressComponents', 'formattedAddress'];
